var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_747_3474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1291 22C11.1083 22 10.1624 21.3292 9.85827 20.3C9.76244 19.9709 9.94994 19.6209 10.2833 19.525C10.6124 19.4292 10.9624 19.6167 11.0583 19.95C11.2333 20.5417 11.8541 20.8792 12.4416 20.7042C12.8083 20.5959 13.0874 20.3167 13.1958 19.95C13.2916 19.6209 13.6416 19.4292 13.9708 19.525C14.2999 19.6209 14.4916 19.9709 14.3958 20.3C14.1666 21.075 13.5708 21.675 12.7916 21.9042C12.5708 21.9709 12.3458 22 12.1249 22H12.1291Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 5.125C11.7792 5.125 11.5 4.84583 11.5 4.5V2.625C11.5 2.27917 11.7792 2 12.125 2C12.4708 2 12.75 2.27917 12.75 2.625V4.5C12.75 4.84583 12.4708 5.125 12.125 5.125Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.625 18.25H4.62505C4.38755 18.25 4.16671 18.1125 4.06255 17.9C3.95838 17.6833 3.98338 17.4292 4.13338 17.2417C4.13755 17.2333 5.25005 15.6583 5.25005 10.75C5.25005 6.95833 8.33338 3.875 12.125 3.875C15.9167 3.875 19 6.95833 19 10.75C19 15.9958 20.0084 17.1292 20.0167 17.1375C20.225 17.3042 20.3042 17.5833 20.2167 17.8333C20.1292 18.0833 19.8917 18.25 19.625 18.25ZM5.63338 17H18.5542C18.1584 15.9917 17.75 14.1292 17.75 10.75C17.75 7.65 15.225 5.125 12.125 5.125C9.02505 5.125 6.50005 7.65 6.50005 10.75C6.50005 14.0417 6.02921 15.9667 5.63338 17Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_747_3474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.25,
    height: 20,
    fill: "white",
    transform: "translate(4 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2365a77d9a19e88aa62cdc4e75530d7f.svg";
export { ForwardRef as ReactComponent };